import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, withModifiers as _withModifiers } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_space = _resolveComponent("a-space")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createBlock(_component_a_modal, {
    visible: _ctx.visible,
    title: _ctx.title,
    footer: null
  }, {
    default: _withCtx(() => [
      _createVNode(_component_a_form, {
        labelCol: { span: 6 },
        wrapperCol: { span: 18 },
        onSubmit: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (_ctx.$emit('save', _ctx.form)), ["prevent"])),
        id: "myForm"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_form_item, { label: "Plant Code" }, {
            default: _withCtx(() => [
              _createVNode(_component_a_input, {
                type: "text",
                value: _ctx.form.plant_code,
                "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.plant_code) = $event)),
                id: "plant_code",
                required: ""
              }, null, 8, ["value"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, { label: "Plant Name" }, {
            default: _withCtx(() => [
              _createVNode(_component_a_input, {
                type: "textarea",
                value: _ctx.form.plant_name,
                "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.plant_name) = $event)),
                id: "plant_name",
                required: ""
              }, null, 8, ["value"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, { label: "Plant Address" }, {
            default: _withCtx(() => [
              _createVNode(_component_a_input, {
                type: "textarea",
                value: _ctx.form.plant_address,
                "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.plant_address) = $event)),
                id: "plant_address",
                required: ""
              }, null, 8, ["value"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, { label: "Districts Served" }, {
            default: _withCtx(() => [
              _createVNode(_component_a_select, {
                mode: "multiple",
                placeholder: "Districts Served",
                value: _ctx.form_action == 'save'?_ctx.selectedItems:_ctx.form.plant_districts,
                style: {"width":"100%"},
                "show-search": "",
                filterOption: _ctx.filterOption,
                "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.plant_districts) = $event))
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.all_districts, (item) => {
                    return (_openBlock(), _createBlock(_component_a_select_option, {
                      key: item.id
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(item.district_name), 1)
                      ]),
                      _: 2
                    }, 1024))
                  }), 128))
                ]),
                _: 1
              }, 8, ["value", "filterOption"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, { "wrapper-col": { span: 18, offset: 6 } }, {
            default: _withCtx(() => [
              _createVNode(_component_a_space, null, {
                default: _withCtx(() => [
                  _createVNode(_component_a_button, {
                    key: "back",
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('cancel')))
                  }, {
                    default: _withCtx(() => _cache[6] || (_cache[6] = [
                      _createTextVNode(" Cancel ")
                    ])),
                    _: 1
                  }),
                  _createVNode(_component_a_button, {
                    key: "submit",
                    type: "primary",
                    htmlType: "submit",
                    loading: false
                  }, {
                    default: _withCtx(() => _cache[7] || (_cache[7] = [
                      _createTextVNode(" Submit ")
                    ])),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["visible", "title"]))
}